// src/components/game/panels/PlayerStatusPanel/PlayerStatusPanel.jsx
import React, { useMemo } from "react";
import useAuthStore from "@store/useAuthStore";
import useGameStore from "@store/useGameStore";
import { GameStatus, PlayerStatusInGame } from "@utils/enums.js";
import { Zap } from 'lucide-react'; // <-- 1. Importamos el ícono
import "./PlayerStatusPanel.css";
import StatusTag from "@components/ui/general/status-tag";
// Removed finalizePlanningApi import - now handled by GameStatusButtonPanel
import { EMPTY_ARRAY } from "@utils/constants";

export default function PlayerStatusPanel() {
  /* ---------- stores ---------- */
  const { user } = useAuthStore();
  const game     = useGameStore((s) => s.game);          // <-- suscrito
  // Removed isPlanPhase - no longer needed here
  

  /* ---------- derived ---------- */
  const players = useMemo(() => game?.players || EMPTY_ARRAY, [game]);
  const current = players.find((p) => p.user_id === user?.id) ?? null;
  // Removed isPlayerReady - no longer needed here
  
//console.log("[PlayerStatusPanel] Current player:", current?.name, "Status:", current);

 // const turnNumber = game?.turn_number ?? 0; // Corregido para usar turn_number
  
  /* turn, status, etc. */
  const gameName   = game?.name  ?? "Game";
  const turnNumber = game?.turn_number;
  // Removed isLoading state - no longer needed here


  const sortedPlayers = useMemo(
    () =>
      [...players].sort(
        (a, b) => (a.pivot?.player_order ?? 0) - (b.pivot?.player_order ?? 0)
      ),
    [players]
  );

  /* ---------- helpers ---------- */
  const getStatusInfo = (status) => {
    switch (status) {
      case PlayerStatusInGame.Deploying:  return { text:"Deploying",  cls:"status-deploying",  ch:"D" };
      case PlayerStatusInGame.Deployed:   return { text:"Deployed",   cls:"status-deployed",   ch:"✔" };
      case PlayerStatusInGame.Planning:   return { text:"Planning",   cls:"status-planning",   ch:"P" };
      case PlayerStatusInGame.Planned:    return { text:"Resolving",  cls:"status-resolving",  ch:"R" };
      default:                            return { text:"Unknown",    cls:"status-unknown",    ch:"?" };
    }
  };

  // Removed handleFinalizePlanning - now handled by GameStatusButtonPanel

  const renderPlayer = (p) => {
    //console.log("Rendering player:"+ p.name, "Status:", p);
    const { text, cls, ch } = getStatusInfo(p.pivot?.status_in_game);
    
    // ✅ VALIDACIÓN MEJORADA - Evitar valores NaN en el cálculo de porcentaje
    let pct = 0;
    
    if (p.pivot?.max_energy && p.pivot?.energy !== undefined) {
      const energy = Number(p.pivot.energy);
      const maxEnergy = Number(p.pivot.max_energy);
      
      // Verificar que ambos valores sean números válidos
      if (!isNaN(energy) && !isNaN(maxEnergy) && 
          isFinite(energy) && isFinite(maxEnergy) && 
          maxEnergy > 0) {
        pct = (energy / maxEnergy) * 100;
        
        // Asegurar que el porcentaje esté en rango válido
        pct = Math.max(0, Math.min(100, pct));
      } else {
        console.warn("[PlayerStatusPanel] Valores de energía inválidos para jugador:", p.name, {
          energy: p.pivot.energy,
          maxEnergy: p.pivot.max_energy
        });
      }
    }

    // ✅ VALIDACIÓN FINAL - Verificar que pct sea un número válido
    if (isNaN(pct) || !isFinite(pct)) {
      console.error("[PlayerStatusPanel] Porcentaje calculado es inválido:", pct);
      pct = 0; // Fallback seguro
    }

    return (
      <div key={p.id} className="player-status-item" title={text}>
        <div className="player-row">
          <div className={`status-circle ${cls}`} title={text}>{ch}</div>
          <span className={`player-name${p.id === current?.id ? " current-player" : ""}`}>
            {p.name}
            {p.type === 'ai' && ' 🤖'}
            <span className="player-id-hidden">[{p.id}]</span>
          </span>
        </div>
        <div className="energy-bar-container" title="Energy">
          <div
            className="energy-bar-fill"
            style={{ width: `${pct}%` }}
          />
          <div className="energy-text">
            <span>{p.pivot?.energy || 0}/{p.pivot?.max_energy || 0}</span>
            {/* 2. Añadimos el ícono de rayo */}
            <Zap className="energy-icon" size={24} fill="var(--color-accent)" />
          </div>
        </div>
      </div>
    );
  };

  /* ---------- render ---------- */
return (
  <div className="player-status-wrapper">
  <div id="player-status-dashboard" className="panel-card">
    {!current ? (
      /* rama SIN jugador actual */
      <p className="empty-msg error">
        Seems like current player doesn't exist
      </p>
    ) : (
      /* rama CON jugador actual */
      <>
        {/* etiqueta de estado del juego */}
        <div className="game-status-header">
          <StatusTag status={game.status} />
          <span className="turn-indicator" role="img" aria-label="Turn">
              🕒 {turnNumber}
          </span>
        </div>

        {/* cabecera nombre + turno */}
        <div className="game-header">
          <h5>{gameName}</h5>
        </div>

        {/* lista de jugadores */}
        {sortedPlayers.map(renderPlayer)}

      </>
    )}
  </div>
  </div>
)};

